module.exports = __webpack_public_path__ + "img/galery-kx5600-2.b3da6c56.png";